import { stringify } from "qs";

import consumerApi from "api/services/consumer-api";
import { Query } from "custom-types/Query";
import { ShopItem } from "custom-types/ShopItem";
import logError from "utils/logError";

export type GetProductsV3Response = {
  data: ShopItem[];
  metadata: {
    availableFilters: AvailableFilter[];
    availableSorts: string[];
    totalCount: number;
  };
};

const getProductsV3 = async ({
  lat,
  lon,
  skip,
  sort,
  take = 15,
  filter,
  fulfillment,
  q,
}: {
  lat: number;
  lon: number;
  skip: number;
  sort?: Query;
  take?: number;
  filter?: Query;
  fulfillment?: string[];
  q?: string;
}): Promise<GetProductsV3Response> => {
  // * Use QS for param serialization. Better at handling objects like filter.
  const queryString = stringify(
    { filter, fulfillment, lat, lon, q, skip, sort, take },

    { arrayFormat: "brackets", indices: false },
  );
  try {
    const { data } = await consumerApi.get<GetProductsV3Response>(
      `/api/products/v3/?${queryString}`,
    );

    return data;
  } catch (e) {
    if (e.statusCode !== 404) {
      logError(e.message, {
        functionName: "getProductsV3",
        service: "consumer",
        statusCode: e.statusCode,
      });
    }

    return {
      data: [],
      metadata: {
        availableFilters: [],
        availableSorts: [],
        totalCount: 0,
      },
    };
  }
};

export type AvailableFilter = ToggleFilter | GroupFilter;

export type ToggleFilter = {
  count: number;
  filterIcon: string | null;
  label: string;
  labelIcon: string | null;
  name: string;
  showCount: boolean;
  sortOrder: number;
  sublabel: string | null;
  type: FilterType.toggle;
};

export type GroupFilter = {
  label: string;
  name: string;
  showCount: boolean;
  sortOrder: number;
  type: FilterType.checkBoxGroup | FilterType.tileGroup;
  values: {
    badge: string | null;
    chip: string | null;
    count: number;
    label: string;
    sortOrder: number;
    type: "checkbox" | "tile";
    value: string;
  }[];
};

export enum FilterType {
  tileGroup = "tile_group",
  checkBoxGroup = "checkbox_group",
  toggle = "toggle",
}

export enum FilterName {
  ProductCategory = "category",
  DispensaryName = "dispensary_name",
  BrandName = "brand_name",
  StrainName = "strain_name",
  THCLevel = "strain_thc",
  CBDLevel = "strain_cbd",
  Weight = "amount",
  StrainCategory = "strain_category",
  StrainEffects = "strain_effects",
  PriceRange = "price",
  Deals = "deal_active",
  BrandVerified = "is_brand_verified",
}

export default getProductsV3;
